<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            placeholder="Tìm kiếm theo mã lô hàng (按批次代碼搜尋)" 
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td class="sticky-col">{{ item.PackageCode }}</td>
                <td>{{ item.BigExportID }}</td>
                <td v-bind:style="{ 'color': display_color(item.Status, bigPackageStatus)}">{{ item.Status | display_value(bigPackageStatus) }}</td>
                <td>
                    <v-edit-dialog :return-value.sync="item.OrderDate" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreExpID': item.StoreExpID})">
                        <div>{{ item.StoreExpID | display_value(storeExpList, 'ID', 'Name') }}</div>
                        <template v-slot:input>
                            <v-select label="Kho nhận" v-model="item.StoreExpID" :items="storeExpList" item-value="ID" item-text="Name"></v-select>
                        </template>
                    </v-edit-dialog>
                </td>
                <td>{{ item.ProductName }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                <td class="text-right">{{ item.TotalSmallPack | currency }}</td>
                <td class="text-right">{{ item.Weight | currency('', 2) }}</td>
                <td class="text-right">{{ item.Volume | currency('', 3) }}</td>
                <td class="text-right" v-if="adminRole">{{ item.Amount | currency('', 2) }}</td>
                <td class="text-right" v-else></td>
                <td class="text-right" v-if="adminRole">{{ item.AmountVND | currency('', 0) }}</td>
                <td class="text-right" v-else></td>
                <td>{{ !storeTQRole ? item.PhoneNumber : '' }}</td>
                <td>{{ !storeTQRole ? item.Address : '' }}</td>
                <td>{{ item.StorePhoneNumber }}</td>
                <td>{{ item.ExDate | display_date }}</td>
                <td>{{ item.ImDate | display_date }}</td>
                <td v-bind:style="{ 'color': display_color(item.State, bigPackageState)}">{{ item.State | display_value(bigPackageState) }}</td>
                <td v-bind:style="{ 'color': display_color(item.PaymentStatus, payment_status)}">{{ item.PaymentStatus | display_value(payment_status) }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td>{{ item.Note }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" color="blue" @click="printPackage(item.ID)" data-toggle="tooltip" title="In tem">fa-print</v-icon>
                  <v-icon medium class="mr-2" @click="exportPackage(item.ID, item.PackageCode)" v-if="(adminRole || storeTQRole) && item.Status == bigPackageEnum.CHUA_CHUYEN" data-toggle="tooltip" title="Xuất kho">fa-shipping-fast</v-icon>
                  <v-icon medium class="mr-2" @click="undoExportPackage(item.ID, item.PackageCode)" v-if="(adminRole || storeTQRole) && item.Status == bigPackageEnum.DA_CHUYEN" data-toggle="tooltip" title="Huỷ xuất kho">fa-undo</v-icon>
                  <v-icon medium class="mr-2" @click="importPackage(item.ID, item.PackageCode)" v-if="(adminRole || storeVNRole) && item.Status == bigPackageEnum.DA_CHUYEN" data-toggle="tooltip" title="Đã nhận">fa-check</v-icon>
                  <v-icon medium class="mr-2 red--text" @click="undoImportPackage(item.ID, item.PackageCode)" v-if="(adminRole) && item.Status == bigPackageEnum.DA_NHAN" data-toggle="tooltip" title="Huỷ nhận">fa-close</v-icon>
                  <v-icon medium class="mr-2" @click="payPackage(item.ID, item.PackageCode)" v-if="adminRole && item.Status == bigPackageEnum.DA_NHAN && !item.PaymentStatus" data-toggle="tooltip" title="Thanh toán">fa-credit-card</v-icon>
                  <v-icon color="red darken-2" medium class="mr-2"  @click="unPayPackage(item.ID, item.PackageCode)" v-if="adminRole && item.Status == bigPackageEnum.DA_NHAN && item.PaymentStatus" data-toggle="tooltip" title="Huỷ thanh toán">fa-credit-card</v-icon>
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)" data-toggle="tooltip" title="Chi tiết"> {{ (packageRole & 8) && item.Status == bigPackageEnum.CHUA_CHUYEN ? 'fa-edit' : 'fa-external-link-alt'}}</v-icon>
                  <v-icon v-on="on" medium class="mr-2" @click="deleteItem(item.ID)" v-if="(packageRole & 4) && item.Status == bigPackageEnum.CHUA_CHUYEN"  data-toggle="tooltip" title="Xoá lô hàng">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <big-package-popup
        :readOnly="currentItem.Status == bigPackageEnum.DA_NHAN && !adminRole && !storeVNRole"
        :dialogPackageDetail="dialogPackageDetail"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></big-package-popup>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import big_package from "@/components/popups/big_package";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import { display_color } from "@/commons/formater";
import _ from "lodash";
import { print_bigpackage, request_detail } from "@/commons/hpod";
import Vue from 'vue';

export default {
  components: {
    "hpo-filter": Filtering,
    "big-package-popup": big_package,
  },
  props: ["dashboard_pagination"],
  data() {    
    return {      
      display_color: display_color,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bigpackage_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      bigPackageEnum: configs.BIG_PACKAGE_STATUS_ENUM,
      bigPackageStatus: configs.BIG_PACKAGE_STATUS,
      bigPackageState: configs.BIG_PACKAGE_STATE,
      dialogPackageDetail: false,
      payment_status: [{value: 0, name: 'Chưa TT', color: 'red'}, {value: 1, name: 'Đã TT', color:'black'}],
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    packageRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.packageRole & 2)});
    },
    storeExpList() {
      let header_item = _.find(this.headers, {value: "StoreExpID"});
      if(header_item) {
        header_item.values = _.map(this.storeExpList, (item) => {
          return {
              value: item.ID,
              name: item.Name
          }
        }) || []
      }
    },
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      total_rows: state => state.bigPackage.all.total,
      currentItem: state => state.bigPackage.selected,
      storeExpList: state => state.storeExp.all.data,
      loading: state => state.bigPackage.loading
    }),
    packageRole() {
      return this.$store.state.authentication.role.BigPackage;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    storeVNRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
    },
    storeTQRoleOnly() {
      return (this.$store.state.authentication.user.roletype == configs.ROLE_TYPE.StoreTQ);
    },
    storeTQRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ2) == configs.ROLE_TYPE.StoreTQ2;
    },
    param() {
      return {
        pagination: this.dashboard_pagination ? this.dashboard_pagination : this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
    },
    headers() {
      let dataType = configs.DATA_TYPE;
      let header_admin = [
        {
          text: "Mã lô (批號)",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          width: 150,
          class: 'sticky-col',
          cellClass: 'sticky-col',
          dataType: dataType["String"]
        },
        {
          text: "Mã PX (出貨單號)",
          value: "BigExportID",
          filterable: true,
          width: 70,
          dataType: dataType["Number"]
        },
        {
          text: "Trạng thái (地位)",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.BIG_PACKAGE_STATUS,
          width: 100
        },
        {
          text: "Kho nhận (收貨倉庫)",
          value: "StoreExpID",
          filterable: true,
          dataType: dataType["Enum"],
          values: [],
          width: 100
        },
        {
          text: "Tên hàng (產品名稱)",
          value: "ProductName",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Tổng mã (代碼總數)",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng kiện (總包數)",
          value: "TotalSmallPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng cân (總重量)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng khối (總容積)",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cước phí (郵資) ¥",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cước phí (郵資) ₫",
          value: "AmountVND",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Điện thoại (電話號碼)",
          value: "PhoneNumber",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Địa chỉ (地址)",
          value: "Address",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "BS.Xe (車牌)",
          value: "StorePhoneNumber",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Xuất kho TQ (交貨日期)",
          value: "ExDate",
          filterable: true,
          width: 140,
          dataType: dataType["Date"]
        },
        {
          text: "Nhập kho VN (收到貨物日期)",
          value: "ImDate",
          filterable: true,
          width: 140,
          dataType: dataType["Date"]
        },
        {
          text: "Tình trạng (地位)",
          value: "State",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.BIG_PACKAGE_STATE,
          width: 100
        },
        {
          text: "Thanh toán (支付)",
          value: "PaymentStatus",
          filterable: true,
          values: this.payment_status,
          dataType: dataType["Enum"]
        },
        {
          text: "Người tạo (創作者)",
          value: "CreatedBy",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Ghi chú (筆記)",
          value: "Note",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác (手術)",
          value: "",
          align: "center",
          width: "150px"
        }
      ];
      return header_admin;
    }
  },
  methods: {
    filter_data: function() {
      if(this.storeTQRoleOnly) {
        this.param.filter.push({
          column: "Status",
          value: 1,
          condition: "does_not_equal",
        });
      }
      this.$store.dispatch("bigPackage/getList", this.param);
      this.$store.dispatch("storeExp/getList");
    },
    importPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'ImportStoreVN', id, `Bạn có chắc chắn nhận lô hàng ${package_code} không?`);
    },
    undoImportPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'ExportStoreCN', id, `Bạn có chắc chắn huỷ nhận lô hàng ${package_code} không?`);
    },
    exportPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'ExportStoreCN', id, `Bạn có chắc chắn xuất lô hàng ${package_code} không?`);
    },
    undoExportPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'UnExportStoreCN', id, `Bạn có chắc chắn huỷ nhận lô hàng ${package_code} không?`);
    },
    payPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'PayPackage', id, `Bạn có chắc chắn thanh toán lô hàng ${package_code} không?`);
    },
    unPayPackage(id, package_code) {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'UnPayPackage', id, `Bạn có chắc chắn huỷ thanh toán lô hàng ${package_code} không?`);
    },
    printPackage(id) {
      request_detail('bigpackage/print', ret => {
          let item = ret.data;
          print_bigpackage(item.PackageCode, item.CreatedDate, item.ExDate, item.NumberOfPack, item.Weight, item.Volume, item.ProductNumber);
      }, Vue.http, id, this.$store.state.authentication.token);
    },
    gotoDetail: function(id) {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      configPaging.itemsPerPage = 5;
      var param = {
        pagination: {
            ...configPaging,
            itemsPerPage: 10000
          }
      };
      
      this.$store.dispatch("bigPackage/getDetail", {'id': id, 'param': param});
      setTimeout(() => {this.dialogPackageDetail = true}, 200);
    },
    editItem: function(item) {
      this.$store.dispatch("bigPackage/setDetail", {'id': id, 'data': item});
    }, 
    deleteItem: function(id) {
      if(this.packageRole & 4) {
        window.getApp.$emit("REQUEST_DELETE_DATA", id);
      }
      else {
        sendErrorNotice('Bạn không có quyền xóa lô hàng.')
      }
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.packageRole & 2) {
        // this.saveItem({
        //     ID: 0,
        //     StoreShortName: 'HN',
        //     ReceivePlaceID: 1,
        //     Weight: 0,
        //     Volume: 0,
        //     Amount: 0,
        //     Status: 0,
        //     Packages: []
        //   });
        this.$store.commit("bigPackage/setDetail", {
          data: {
            ID: 0,
            PackageCode: '',
            ReceivePlaceID: 1,
            Weight: 0,
            Volume: 0,
            Amount: 0,
            Status: -1,
            Packages: []
          }
        });
        this.dialogPackageDetail = true;
      }
      else {
        sendErrorNotice('Bạn không có quyền thêm mới lô hàng.')
      }
    },
    saveItem(item) {
      this.$store.dispatch("bigPackage/setDetail", {
        data: item,
        id: item.ID,
        param: this.param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
      setTimeout(this.filter_data, 200);
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.packageRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'ExportStoreCN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.DA_CHUYEN
        });
      }
      else if(action == 'UnExportStoreCN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.CHUA_CHUYEN
        });
      }
      else if(action == 'ImportStoreVN') {
        this.saveItem({
          ID: id,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.DA_NHAN
        });
      }
      else if(action == 'PayPackage') {
        this.saveItem({
          ID: id,
          PaymentStatus: 1
        });
      }
      else if(action == 'UnPayPackage') {
        this.saveItem({
          ID: id,
          PaymentStatus: 0
        });
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("CONFIRMED_ACTION");
  }
};
</script>
<style scoped>
::v-deep .sticky-col {
    position: sticky !important;
    left: 0;
    z-index: 2;
    background: white;
}
::v-deep .v-data-table__wrapper > table > thead > tr > th.sticky-col {
    z-index: 3;
}
</style>